import { render, staticRenderFns } from "./WordSlotSet.vue?vue&type=template&id=0a5906fe&scoped=true&"
import script from "./WordSlotSet.vue?vue&type=script&lang=js&"
export * from "./WordSlotSet.vue?vue&type=script&lang=js&"
import style0 from "./WordSlotSet.vue?vue&type=style&index=0&id=0a5906fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5906fe",
  null
  
)

export default component.exports